<div class="spinner layout-mask flex justify-content-center align-items-center" [ngClass]="{'modal-in ': overlay}">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
